import { useTranslation } from 'react-i18next';

import { TranslationFunction, useTranslator } from 'ggApp/modules/translator';

const gCashHackSuffix = 'CashBucks';

const translationHack = (t: TranslationFunction, countryCode: string): TranslationFunction => {
    const gCashName = countryCode === 'US' ? 'Bucks' : 'Cash';
    return (key: string, withValues?: Record<string, any>) => {
        const hackedKey = `${key}${gCashHackSuffix}`;
        const hackedCopy = t(hackedKey, { gCashName, ...withValues });

        return hackedCopy !== hackedKey ? hackedCopy : t(key, { gCashName, ...withValues });
    };
};

export function useTranslatorCashHack(countryCode: string): TranslationFunction {
    const { t } = useTranslator();

    return translationHack(t, countryCode);
}

export function useTranslationCashHack(countryCode: string): TranslationFunction {
    const { t } = useTranslation();

    return translationHack(t, countryCode);
}
